import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface SetShowWelcomeScreenParams {
  showWelcomeScreen: boolean;
}

export class SetShowWelcomeScreenRequest extends Request<SetShowWelcomeScreenParams, IResult> {
  constructor(params: SetShowWelcomeScreenParams) {
    super('setShowWelcomeScreen', params);
  }
}
